import React from "react";
import cn from "classnames";

const Goal = ({ name, checked }) => (
  <label className="team-decision-label">
    <span
      className={cn("status", {
        status_complete: checked,
        status_incomplete: !checked
      })}
    />
    <p>{name}</p>
  </label>
);

export default Goal;



// WEBPACK FOOTER //
// ./src/components/dashboard/Goal.js